import React from 'react';
import useMedia from '~/hooks/useMedia';
import { Translate } from '~/i18n';
import { TopSectionContactForm } from './top-section-contact-form';

export const TicketsFeaturesTopSection = ({ pageName }: any) => {
   const isMobile = useMedia(1100);

   if (!isMobile) {
      return (
         <div className="flex flex-col lg:flex-row w-full gap-5 h-full mt-16 lg:mt-12 mb-6 ">
            <div className="flex flex-col w-full lg:w-[70%]">
               <TopSectionHero pageName={pageName} />
               <TopSectionTestimonials pageName={pageName} />
            </div>
            <TopSectionContactForm />
         </div>
      );
   } else {
      return (
         <div className="flex flex-col w-full gap-5 h-full mt-20 lg:mt-12 mb-6 ">
            <TopSectionHero pageName={pageName} />
            <TopSectionContactForm />
            <TopSectionTestimonials pageName={pageName} />
         </div>
      );
   }
};

const TopSectionHero = ({ pageName }: any) => {
   const isMobile = useMedia(1100);
   return (
      <div
         className="rounded-3xl bg-white p-5 lg:py-8 lg:px-16 relative bg-cover bg-no-repeat bg-center lg:mb-6"
         style={{
            backgroundImage: "url('/images/tickets-page/top-section-bg.png')",
         }}>
         <img
            src="/images/tickets-page/arrow.png"
            className={`absolute ${
               isMobile
                  ? 'rotate-[130deg] bottom-1 !-right-2 rtl:!right-[initial] rtl:!left-0 rtl:!rotate-90'
                  : null
            } lg:top-5 -right-3 rtl:-left-3 rtl:right-[initial] rtl:rotate-180 z-10`}
         />
         <img
            src={`/images/tickets-page/${pageName}.png`}
            height="30px"
            width="75px"
            className="mb-5 lg:mb-2"
         />
         <span className="text-[#212528] font-bold text-xs mb-2">
            {' '}
            <Translate id={`tickets:${pageName} feature`} />
         </span>
         <h1 className="font-black text-[#1D4ED8] text-5xl lg:text-7xl mb-8">
            <Translate id={`tickets:${pageName} main headline`} />
         </h1>
         <span className="font-medium text-[#353A3F] text-lg flex pr-8 lg:pr-0">
            <Translate id={`tickets:${pageName} sub headline`} />
         </span>
      </div>
   );
};

const TopSectionTestimonials = ({ pageName }: any) => {
   return (
      <div className="grid grid-cols-none lg:grid-cols-2 gap-5">
         <div className="bg-white shadow-sm font-medium text-2xl text-[#353A3F] gap-4 lg:gap-8 rounded-3xl flex flex-col lg:flex-row items-center justify-center px-8 lg:px-10 py-10 lg:py-20 relative before:w-[6px] before:bg-[#1D4ED8] before:h-32 lg:before:h-44 before:rounded-xl before:absolute before:top-0 before:bottom-0 before:left-0 rtl:before:left-[initial] rtl:before:right-0 before:m-auto">
            <img src="/images/tickets-page/Thunder.svg" />
            <div>
               <Translate id={`tickets:${pageName} testimonial 1`} />
            </div>
         </div>
         <div className="bg-white shadow-sm font-medium text-2xl text-[#353A3F] gap-4 lg:gap-8 rounded-3xl flex flex-col lg:flex-row items-center justify-center px-8 lg:px-10 py-10 lg:py-20 relative before:w-[6px] before:bg-[#1D4ED8] before:h-32 lg:before:h-44 before:rounded-xl before:absolute before:top-0 before:bottom-0 before:left-0 rtl:before:left-[initial] rtl:before:right-0 before:m-auto">
            <img src="/images/tickets-page/Group.svg" />
            <div>
               <Translate id={`tickets:${pageName} testimonial 2`} />
            </div>
         </div>
      </div>
   );
};
